import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../../config'
import { HTTPv2 } from '@/services/config'

class PhotoFlowServiceV2 extends Service {
  path = 'parametrizacaofluxofotos'

  constructor() {
    super(HTTPv2)
  }

  async checkParametrizationExists(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/existe-parametrizacao`, {
      params: removePropertyEmpty(params),
    })
    return httpResponse
  }

  async checkThirdPartyParametrizationExists() {
    const httpResponse = await this.httpClient.get(`${this.path}/existe-parametrizacao-terceiro`)
    return httpResponse
  }
}

export const photoFlowServiceV2 = new PhotoFlowServiceV2()
